import { ContactSection } from "./sections";

const Contact = () => {
  return (
    <>
      <ContactSection />
    </>
  );
};

export default Contact;
